<template>
    <div class="affiliate-report-page">
    
        <div v-if="!isAuthenticated" class="password-overlay">
            <div class="password-modal">
                <h4 class="mb-3">🔒 Enter Password to View Report</h4>
                <input type="password" v-model="enteredPassword" @keyup.enter="verifyPassword" class="form-control mb-3" placeholder="Password" />
                <button @click="verifyPassword" class="btn btn-primary btn-block">
                        Access Report
                    </button>
                <p v-if="authError" class="text-danger mt-2">{{ authError }}</p>
            </div>
        </div>
    
        <div v-show="isAuthenticated">
    
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h2 class="page-title">Affiliate Sales Report</h2>
                <button @click="exportCSV" class="btn btn-primary">
                        <i class="fa fa-download mr-2"></i> Download Report
                    </button>
            </div>
    
            <div class="report-card p-4">
    
                <div class="d-flex justify-content-between flex-wrap mb-3">
    
                    <div class="search-wrapper mb-2">
                        <i class="fa fa-search search-icon"></i>
                        <input v-model="searchQuery" @input="filterTable" type="text" placeholder="Search..." class="search-input" />
                    </div>
    
                    <div class="d-flex flex-wrap">
    
                        <select v-model="selectedUserFilter" class="filter-select" @change="handleFilterChange">
                                    <option value="Recent Users">Recent Users</option>
                    <option value="Top Users">Top Users</option>
                    <option value="New Users">New Users</option>
                                </select>
    
                        <select v-model="selectedOrderFilter" class="filter-select" @change="handleFilterChange">
                                  <option>Recent Orders</option>
                                  <option>Highest Value</option>
                                  <option>Lowest Value</option>
                                </select>
    
                        <select v-if="selectedDateType === 'bulanan'" v-model="selectedMonth" class="filter-select" @change="handleFilterChange">
              <option v-for="m in monthList" :key="m.value" :value="m.value">
                {{ m.label }}
              </option>
            </select>
    
    
                    </div>
    
                </div>
    
                <div class="table-responsive">
                    <table class="table table-border table-hover custom-table">
                        <thead style="background: var(--Gray-50, #F9FAFB);">
                            <tr>
                                <th>Class Name</th>
                                <th>User</th>
                                <th>Email User</th>
                                <th>Agent Staff</th>
                                <th>Date</th>
                                <th>Repeat Customer</th>
                                <th>Bilangan Terjual</th>
                                <th>Jumlah Nilai (RM)</th>
                                <th>Profit</th>
                                <th>Commission</th>
                            </tr>
                        </thead>
    
                        <tbody>
                            <tr v-for="item in paginatedData" :key="item.id">
                                <td>{{ item.ClassName }} </td>
                                <td>{{ item.CustomerName }}</td>
                                <td>{{ item.Email }}</td>
                                <td>{{ item.AgentName }}</td>
                                <td>{{ item.Date }}</td>
    
                                <td>
                                    <span class="status-badge" :class="item.RepeatCustomer ? 'yes' : 'no'">
                                        {{ item.RepeatCustomer ? 'Yes' : 'No' }}
                                      </span>
                                </td>
    
                                <td>{{ item.CountSale }}</td>
                                <td>{{ item.TotalAmount }}</td>
                                <td>{{ item.Profit }}</td>
                                <td>{{ item.Commission }}</td>
    
    
                            </tr>
                        </tbody>
                    </table>
                </div>
    
                <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
    
                    <small>
                                Showing {{ startRow }} to {{ endRow }} of {{ tableData.length }} entries
                              </small>
    
                    <ul class="pagination mb-0 mt-2">
                        <li class="page-item" :class="{ disabled: page === 1 }" @click="goPrev">
                            <a class="page-link">‹</a>
                        </li>
    
                        <li class="page-item" :class="{ active: page === 1 }" @click="goPage(1)">
                            <a class="page-link">1</a>
                        </li>
    
                        <li v-if="page > 3" class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
    
                        <li v-for="p in middlePages" :key="p" class="page-item" :class="{ active: page === p }" @click="goPage(p)">
                            <a class="page-link">{{ p }}</a>
                        </li>
    
                        <li v-if="page < totalPages - 2" class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
    
                        <li v-if="totalPages > 1" class="page-item" :class="{ active: page === totalPages }" @click="goPage(totalPages)">
                            <a class="page-link">{{ totalPages }}</a>
                        </li>
    
                        <li class="page-item" :class="{ disabled: page === totalPages }" @click="goNext">
                            <a class="page-link">›</a>
                        </li>
                    </ul>
    
                    <div>
                        Show
                        <select v-model="perPage" @change="updatePerPage" class="perPage-select">
                                  <option :value="10">10</option>
                                  <option :value="25">25</option>
                                  <option :value="50">50</option>
                                </select> entries
                    </div>
    
                </div>
            </div>
    
        </div>
    
    </div>
</template>
  
<script>
// Define the required password here (reusing the one provided previously)
const ACCESS_PASSWORD = "Flyhigh192077**";

export default {
    data() {
        return {
            // --- AUTHENTICATION DATA ---
            isAuthenticated: false,
            enteredPassword: '',
            authError: '',
            // ---------------------------

            searchQuery: "",
            selectedUserFilter: "Recent Users",
            selectedOrderFilter: "Recent Orders",
            selectedDateType: "bulanan",
            selectedMonth: this.getCurrentMonth(),

            monthList: [
                { label: "Jan 2025", value: "2025-01" },
                { label: "Feb 2025", value: "2025-02" },
                { label: "Mar 2025", value: "2025-03" },
                { label: "Apr 2025", value: "2025-04" },
                { label: "May 2025", value: "2025-05" },
                { label: "Jun 2025", value: "2025-06" },
                { label: "Jul 2025", value: "2025-07" },
                { label: "Aug 2025", value: "2025-08" },
                { label: "Sep 2025", value: "2025-09" },
                { label: "Oct 2025", value: "2025-10" },
                { label: "Nov 2025", value: "2025-11" },
                { label: "Dec 2025", value: "2025-12" },

                { label: "Jan 2026", value: "2026-01" },
                { label: "Feb 2026", value: "2026-02" },
                { label: "Mar 2026", value: "2026-03" },
                { label: "Apr 2026", value: "2026-04" },
                { label: "May 2026", value: "2026-05" },
                { label: "Jun 2026", value: "2026-06" },
                { label: "Jul 2026", value: "2026-07" },
                { label: "Aug 2026", value: "2026-08" },
                { label: "Sep 2026", value: "2026-09" },
                { label: "Oct 2026", value: "2026-10" },
                { label: "Nov 2026", value: "2026-11" },
                { label: "Dec 2026", value: "2026-12" }
            ],

            tableData: [],
            originalData: [],

            page: 1,
            perPage: 10,
        };
    },

    computed: {
        totalPages() {
            return Math.ceil(this.tableData.length / this.perPage);
        },
        paginatedData() {
            const start = (this.page - 1) * this.perPage;
            return this.tableData.slice(start, start + this.perPage);
        },
        startRow() {
            return (this.page - 1) * this.perPage + 1;
        },
        endRow() {
            return Math.min(this.page * this.perPage, this.tableData.length);
        },
        middlePages() {
            const pages = [];

            for (let i = this.page - 1; i <= this.page + 1; i++) {
                if (i > 1 && i < this.totalPages) {
                    pages.push(i);
                }
            }

            return pages;
        }
    },
    async mounted() {
        // 🔥 Check if user was authenticated earlier
        let savedAuth = localStorage.getItem("affiliateReportAuth");

        if (savedAuth === "true") {
            this.isAuthenticated = true;
            this.GetListAffiliateStaff(); // Auto-load data
            return;
        }

        // Still need login check for app
        let isAuth = await this.UserAuth();
        if (!isAuth) this.GoToLogin();
    },


    methods: {
        getCurrentMonth() {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    return `${year}-${month}`
  },
        // --- NEW METHOD: PASSWORD CHECK ---
        verifyPassword() {
            this.authError = '';

            if (this.enteredPassword === ACCESS_PASSWORD) {
                this.isAuthenticated = true;
                this.enteredPassword = '';

                // 🔥 Save auth state so refresh won't require re-entering password
                localStorage.setItem("affiliateReportAuth", "true");

                this.GetListAffiliateStaff();
            } else {
                this.authError = 'Incorrect password. Please try again.';
            }
        },
        // ----------------------------------

        filterTable() {
            this.filterAll();
        },
        filterAll() {
            if (!this.originalData) return;

            let data = [...this.originalData];

            // -------------------------------
            // 1. DATE/MONTH FILTER
            // -------------------------------
            if (this.selectedDateType === 'bulanan' && this.selectedMonth) {
                const selectedPrefix = this.selectedMonth;

                data = data.filter(item => {
                    if (item.Date) {
                        const itemPrefix = item.Date.substring(0, 7);
                        return itemPrefix === selectedPrefix;
                    }
                    return false;
                });
            }


            // -------------------------------
            // 2. SEARCH FILTER
            // -------------------------------
            if (this.searchQuery.trim() !== "") {
                let q = this.searchQuery.toLowerCase();
                data = data.filter(x =>
                    (x.ClassName || "").toLowerCase().includes(q) ||
                    (x.CustomerName || "").toLowerCase().includes(q) ||
                    (x.AgentName || "").toLowerCase().includes(q)
                );
            }

            // -------------------------------
            // 3. ORDER FILTER (Sorting)
            // -------------------------------
            switch (this.selectedOrderFilter) {
                case "Recent Orders":
                    data.sort((a, b) => new Date(b.Date) - new Date(a.Date));
                    break;
                case "Highest Value":
                    data.sort((a, b) => this.parseAmount(b.TotalAmount) - this.parseAmount(a.TotalAmount));
                    break;
                case "Lowest Value":
                    data.sort((a, b) => this.parseAmount(a.TotalAmount) - this.parseAmount(b.TotalAmount));
                    break;
            }


            // -------------------------------
            // 4. USER FILTER (Sorting)
            // -------------------------------
            switch (this.selectedUserFilter) {
                case "Recent Users":
                    data.sort((a, b) => new Date(b.Date) - new Date(a.Date));
                    break;
                case "Top Users":
                    data.sort((a, b) => this.parseAmount(b.TotalAmount) - this.parseAmount(a.TotalAmount));
                    break;
                case "New Users":
                    data.sort((a, b) => new Date(a.Date) - new Date(b.Date));
                    break;
            }


            // Update the table data and reset pagination
            this.tableData = data;
            this.page = 1;
        },

        handleFilterChange() {
            this.filterAll();
        },

        goPrev() {
            if (this.page > 1) this.page--;
        },
        goNext() {
            if (this.page < this.totalPages) this.page++;
        },
        goPage(n) {
            this.page = n;
        },
        updatePerPage() {
            this.page = 1;
        },
        parseAmount(amountString) {
            if (typeof amountString !== 'string') return 0;
            const match = amountString.match(/(\d[\d\s,.]*)/);
            if (match) {
                return parseFloat(match[0].replace(/[^0-9.]/g, '')) || 0;
            }
            return 0;
        },

        async GetListAffiliateStaff() {
            // Only proceed if authenticated
            if (!this.isAuthenticated) return;

            try {
                this.isLoading = true;
                const response = await this.$API.get(this.$GetListAllTransaction);

                if (response.status === 200 && response.data) {
                    this.isLoading = false;

                    // Filter data for AffiliateTypeId 1 (Affiliate Staff)
                    const filteredData = response.data.filter(item =>
                        item.AffiliateTypeId === 1
                    );

                    this.originalData = filteredData;
                    this.filterAll();
                }
            } catch (err) {
                console.error("Error loading report:", err);
            }
        },

        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/login") {
                this.$router.push({
                    path: "/login",
                    query: { targetUrl: this.$router.currentRoute.fullPath }
                });
            }
        },

        // ------------------------------------------------------------------
        // CSV Export
        // ------------------------------------------------------------------
        exportCSV() {
            if (this.tableData.length === 0) {
                alert("No data to export.");
                return;
            }

            const headers = [
                "Class Name",
                "User",
                "Agent Staff",
                "Date",
                "Repeat Customer",
                "Bilangan Terjual",
                "Jumlah Nilai (RM)",
                "Profit",
                "Commission"
            ];

            const csvRows = this.tableData.map(item => [
                `"${(item.ClassName || '').replace(/"/g, '""')}"`,
                `"${(item.CustomerName || '').replace(/"/g, '""')}"`,
                `"${(item.AgentName || '').replace(/"/g, '""')}"`,
                `"${item.Date || ''}"`,
                `"${item.RepeatCustomer ? 'Yes' : 'No'}"`,
                item.CountSale,
                `"${item.TotalAmount || ''}"`,
                `"${item.Profit || ''}"`,
                `"${item.Commission || ''}"`
            ].join(','));

            const csvContent = [
                headers.join(','),
                ...csvRows
            ].join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);

            link.setAttribute("href", url);

            const date = new Date().toISOString().slice(0, 10);
            let filename = `Affiliate_Report_${date}`;

            if (this.selectedDateType === 'bulanan' && this.selectedMonth) {
                filename = `Affiliate_Report_${this.selectedMonth}`;
            }

            link.setAttribute("download", `${filename}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
</script>
  
<style scoped>
.btn-primary {
    background-color: #2563eb;
    border-color: #2563eb;
    color: white;
    font-weight: 500;
}

.affiliate-report-page {
    background: #f7f7f7;
    min-height: 100vh;
}

.page-title {
    font-weight: 600;
}

.report-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
}

/* SEARCH BAR */

.search-wrapper {
    position: relative;
}

.search-input {
    padding-left: 35px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #ddd;
}

.search-icon {
    position: absolute;
    top: 10px;
    left: 12px;
    font-size: 14px;
    color: #6c757d;
}

/* FILTER SELECT */

.filter-select {
    height: 40px;
    margin-left: 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
    padding: 0 10px;
}

/* STATUS BADGES */

.status-badge {
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
}

.status-badge.yes {
    background: #d1fae5;
    color: #059669;
}

.status-badge.no {
    background: #ffe4e6;
    color: #e11d48;
}

/* TABLE */

.custom-table th {
    font-size: 14px;
    color: #6c757d;
}

/* PAGINATION */

.pagination .page-item.active .page-link {
    background: #2563eb;
    border-color: #2563eb;
    color: #fff;
}

.page-link {
    border-radius: 6px !important;
}

/* Per-page select */

.perPage-select {
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
}

/* --- NEW STYLES FOR PASSWORD POPUP --- */

.password-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
    /* Above other content */
}

.password-modal {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.text-danger {
    color: #dc3545;
}

/* -------------------------------------- */
</style>